import { isDev } from '../../../../dev/utils/isDev';
import { Nullable } from '../../types/Nullable';
import { testIsEmailValid } from '../../utils/testIsEmailValid';

export const testCanLogin = ({
  email,
  password,
}: {
  email: Nullable<string>;
  password: Nullable<string>;
}) => isDev || (testIsEmailValid(email) && Boolean(password));
